export const completeTraining = ({ form, store, db, rowItem }) => {
    const materials = Object.values(store.state["Home/TrainingMaterial"] || {})
        .filter((m) => m.IncludeInMatrix)
        .map((m) => ({ id: m.ID, label: m.Title }));

    const users = Object.values(store.state.users || {})
        .filter((u) => u.main)
        .map((u) => ({ id: u.key, label: u.name }));

    if(rowItem) {
        form.setValues({
            "MaterialID": rowItem.ID
        });
    }

    form.setConfig({
        "title": "Complete Training",
        "type": "ignoreAutoAction",
        "submitButtonLabel": "Mark Complete",
        "fields": [{
            "label": "Training Material",
            "name": "MaterialID",
            "type": "dropdown",
            "dropdownData": materials,
            "idKey": "id",
            "labelKey": "label"
        }, {
            "label": "Users",
            "name": "UserIDs",
            "type": "dropdown",
            "multiple": true,
            "dropdownData": users,
            "idKey": "id",
            "labelKey": "label"
        }, {
            "label": "Date Completed",
            "name": "DateCompleted",
            "type": "date"
        }],
        async postSubmitHook({ data }) {
            const materialId = data.MaterialID;
            const dateCompleted = data.DateCompleted;
            const userIds = Array.isArray(data.UserIDs) ? data.UserIDs : [data.UserIDs];
            for (const userId of userIds) {
                if (!userId) continue;
                await db.update(`Home/TrainingMaterial/${materialId}/Users/${userId}`, {
                    "Date": dateCompleted
                });
            }
        }
    });

    form.toggle();
};
